<template>
  <div class="bg-background-light border-b-[1px] border-bw-grey">
    <div class="pt-12 pb-28 flex flex-col align-center">
      <div class="container flex flex-col justify-center text-center py-12">
        <div class="responsive-title-2 font-bold mb-4">{{ t('privacyPolicy.title') }}</div>
        <div class="responsive-body-medium ">{{ t('privacyPolicy.description1') }} <br><br> {{ t('privacyPolicy.description2') }}</div>
      </div>
      <div class="container w-100 space-y-1">
        <div v-for="(item, index) in privacyPolicies" :key="index" class="faq-item faq-question">
          <div class="flex flex-col container justify-between ">
            <button @click="toggle(index)" class="flex justify-between align-center">
              <div class="title-faq text-left responsive-title-5">{{ t(`privacyPolicy.sections.${item.key}.title`) }}</div>
              <span :class="{ 'chevron': true, 'open': item.open }">
                  <img src="@/assets/icons/svg/chevron.svg" alt="Chevron" />
              </span>
            </button>
            <div v-if="item.open" class="faq-answer">
              <div v-html="t(`privacyPolicy.sections.${item.key}.content`)"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';

const { t } = useI18n();

const privacyPolicies = ref([
  {key:'kindOfData', open: false},
  {key:'whyCollect', open: false},
  {key:'whatSecurity', open: false},
  {key:'howControl', open: false},
  {key:'communications', open: false},
  {key:'cookiesStatement', open: false},
  {key:'cookie', open: false},
  {key:'howUsed', open: false},
]);

const toggle = (index) => {
  privacyPolicies.value[index].open = !privacyPolicies.value[index].open;
};

</script>

<style scoped>
.faq-question {
  width: 100%;
  cursor: pointer;
  padding: 10px 0;
  border-bottom: 1px solid #eaeaea;
}

.faq-answer {
  padding: 10px 0;
  border-bottom: 1px solid #eaeaea;
  font-size: 16px;
  color: #8C8B94;
}

.chevron {
  transition: transform 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid #8C8B94;
  transform: rotate(-90deg);
}

.chevron.open {
  transform: rotate(90deg);
}

.title-faq {
  width: 80% !important;
}
</style>

